import React from 'react'
import { IntegrationsBanner } from '@chilipiper/integrations-banner'
import { Button } from '@chilipiper/design-system/src/new'
import { Link } from '@chilipiper/navigation'
import { useCalendarIntegration } from '@chilipiper/integrations'
import { useGetZoomConnectionStatus } from '@chilipiper/meeting-location-integrations'
import { useRingcentralStatus } from '@chilipiper/meeting-location-integrations'
import { useWebexStatus } from '@chilipiper/meeting-location-integrations'
import { useGotomeetingStatus } from '@chilipiper/meeting-location-integrations'
import { useFireSessionContext } from '@chilipiper/fire-session'
import { routes } from '../routes/routes'

export const BrokenIntegrationsBanner = () => {
  const { userId } = useFireSessionContext()
  const { data: calendarIntegration } = useCalendarIntegration(userId)
  const userCalendarIntegration = calendarIntegration?.connectionStatuses[userId]
  const { data: zoomIntegration } = useGetZoomConnectionStatus()
  const { ringcentralData } = useRingcentralStatus()
  const { webexData } = useWebexStatus()
  const { gotomeetingData } = useGotomeetingStatus()

  const isCalendarIntegrationInTrouble =
    userCalendarIntegration?.primary.type === 'Success' &&
    userCalendarIntegration.primary.value.type === 'InTrouble'

  const brokenUserIntegrations = [
    ...(zoomIntegration === 'InTrouble' ? ['Zoom'] : []),
    ...(ringcentralData?.connectionStatus === 'InTrouble' ? ['RingCentral'] : []),
    ...(webexData?.connectionStatus === 'InTrouble' ? ['Webex'] : []),
    ...(gotomeetingData?.connectionStatus === 'InTrouble' ? ['GoToMeeting'] : []),
    ...(isCalendarIntegrationInTrouble ? ['Calendar'] : []),
    ...(userCalendarIntegration?.primary.type === 'Failure' ? ['Calendar'] : []),
  ]

  return (
    <IntegrationsBanner
      brokenUserIntegrations={brokenUserIntegrations}
      integrationsPageButton={
        <Link to={routes.integrations}>
          {linkProps => (
            <Button as='a' variant='major' {...linkProps}>
              Go to Integrations
            </Button>
          )}
        </Link>
      }
    />
  )
}
